import React from 'react';

const LevelDot = ({active}) => {
	return (
		(active === "true") ? (<div className="Level-dot active"></div>
			) : (<div className="Level-dot"></div>)
		);
};

export default LevelDot;